import { render, staticRenderFns } from "./CommentItemJLP.vue?vue&type=template&id=7b17bd92&scoped=true&"
import script from "./CommentItemJLP.vue?vue&type=script&lang=ts&"
export * from "./CommentItemJLP.vue?vue&type=script&lang=ts&"
import style0 from "./CommentItemJLP.vue?vue&type=style&index=0&id=7b17bd92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b17bd92",
  null
  
)

export default component.exports